<template>
  <div class="log-event-container">
    <h2 class="heading-text">{{ $t('logEvent') }}</h2>
    <div class="mt-2 mb-4"><hr /></div>

    <v-card class="card2" style="margin-top: 1rem">
      <div class="d-flex align-center gap-2">
        <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="img" width="20" height="20">
        <p class="card-title">{{ $t('dateRange') }}</p>
      </div>

      <v-row class="items-center mt-2">
        <!-- Start Date -->
        <v-col cols="12" sm="4">
          <div class="mb-1 d-flex align-center" style="gap: 2px">
            <label for="Start Date" class="text-sm font-medium text-gray-700">
              {{ $t('startDate') }}
            </label>
            <v-tooltip location="top" max-width="230px">
              <template v-slot:activator="{ props }">
                <img
                  v-bind="props"
                  src="@/assets/intent group toolip.svg"
                  alt="info"
                  width="18"
                  height="18"
                  style="cursor: pointer; margin-left: 4px;"
                />
              </template>
              <span>{{ $t('selectStartDateFilter') }}</span>
            </v-tooltip>
          </div>
          <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
            <template #activator="{ props }">
              <v-text-field
                :model-value="formatDateDisplay(startDate)"
                readonly
                variant="plain"
                v-bind="props"
                density="compact"
                color="grey"
                class="date-style"
              >
                <template #prepend-inner>
                  <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="startDate" @update:model-value="val => { startDate = formatDate(val); startDateFlag = false }" color="red"></v-date-picker>
          </v-menu>
        </v-col>

        <div class="date-divider">-</div>

        <!-- End Date -->
        <v-col cols="12" sm="4">
          <div class="mb-1 d-flex align-center" style="gap: 2px">
            <label for="End Date" class="text-sm font-medium text-gray-700">
              {{ $t('endDate') }}
            </label>
            <v-tooltip location="top" max-width="230px">
              <template v-slot:activator="{ props }">
                <img
                  v-bind="props"
                  src="@/assets/intent group toolip.svg"
                  alt="info"
                  width="18"
                  height="18"
                  style="cursor: pointer; margin-left: 4px;"
                />
              </template>
              <span>{{ $t('selectEndDateFilter') }}</span>
            </v-tooltip>
          </div>
          <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
            <template #activator="{ props }">
              <v-text-field
                :model-value="formatDateDisplay(endDate)"
                readonly
                variant="plain"
                v-bind="props"
                density="compact"
                color="grey"
                class="date-style"
              >
                <template #prepend-inner>
                  <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="endDate" @update:model-value="val => { endDate = formatDate(val); endDateFlag = false }" color="red"></v-date-picker>
          </v-menu>
        </v-col>

        <!-- Search Button -->
        <v-col cols="12" sm="1">
          <div class="search-divider">
            <div class="mt-8">
              <button type="button" @click="Search" class="search-btn">
                <img src="@/assets/search.svg" alt="img" width="20" height="20" style="margin-top: 6px;">
              </button>
            </div>
            <div class="action-divider mt-2"></div>
          </div>
        </v-col>

        <!-- Advance Filters -->
        <v-col cols="12" sm="2">
          <div class="advance-filters">
            <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
            <span style="color: #C32E0E; font-size: 10px;">{{ $t('advanceFilters') }}</span>
            <v-switch v-model="detailsExpanded" class="memory-switch" hide-details></v-switch>
          </div>
        </v-col>
      </v-row>

      <v-card v-if="detailsExpanded" class="advanced-filter-card mt-8 pa-4 mb-2">
        <div class="d-flex align-center gap-2">
          <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
          <p class="card-title">{{ $t('filtersOptions') }}</p>
        </div>
        <v-row class="mt-4">
          <v-col cols="12" sm="6" md="4">
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="API Name" class="text-sm font-medium text-gray-700">
                {{ $t('apiNameCol') }}
              </label>
              <v-tooltip location="top" max-width="320px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_apiNameTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-text-field
              v-model="apiNameQuery"
              variant="plain"
              density="comfortable"
              class="modern-input"
              :placeholder="$t('apiNameCol')"
              color="grey"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <!-- Create By -->
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Create By" class="text-sm font-medium text-gray-700">
                {{ $t('createByCol') }}
              </label>
              <v-tooltip location="top" max-width="280px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_createByTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-text-field
              v-model="createByQuery"
              variant="plain"
              density="comfortable"
              class="modern-input"
              :placeholder="$t('createByCol')"
              color="grey"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <!-- Status Code -->
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Status Code" class="text-sm font-medium text-gray-700">
                {{ $t('statusCodeCol') }}
              </label>
              <v-tooltip location="top" max-width="300px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_statusCodeTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-select
              v-model="statusCodeQuery"
              :items="[
                { title: $t('all'), value: null },
                ...statusCode.map((item) => ({
                  title: item.name,
                  value: item.value,
                })),
              ]"
              variant="plain"
              density="comfortable"
              :placeholder="$t('statusCodeCol')"
              class="modern-input"
              color="grey"
            ></v-select>
          </v-col>
        </v-row>
        <v-row style="margin-top: -22px;">
          <v-col cols="12" sm="3" md="4">
            <!-- Status API -->
             <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Status API" class="text-sm font-medium text-gray-700">
                {{ $t('statusApiCol') }}
              </label>
              <v-tooltip location="top" max-width="320px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_statusApiTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-select
              v-model="statusApiQuery"
              :items="[
                { title: $t('all'), value: null },
                ...statusApi.map((item) => ({
                  title: item.name,
                  value: item.value,
                })),
              ]"
              variant="plain"
              density="comfortable"
              :placeholder="$t('statusApiCol')"
              class="modern-input"
              color="grey"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="3" md="4">
            <!-- Action -->
            <div class="mb-1 d-flex align-center" style="gap: 2px">
              <label for="Action" class="text-sm font-medium text-gray-700">
                {{ $t('action') }}
              </label>
              <v-tooltip location="top" max-width="350px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t('_actionTooltip') }}</span>
              </v-tooltip>
            </div>
            <v-select
              v-model="actionQuery"
              :items="[
                { title: $t('all'), value: null },
                ...actionList.map((item) => ({
                  title: item.name,
                  value: item.value,
                })),
                { title: 'Login', value: 'Login' },
              ]"
              variant="plain"
              density="comfortable"
              :placeholder="$t('action')"
              class="modern-input"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="3" md="1">
            <button @click="refreshData" type="button" class="download-btn">
              <span style="color: #ffffff; font-size: 14px;">{{ $t('applyFilter') }}</span>
            </button>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="clear-button-style">
            <button type="button" :disabled="!hasActiveFilters" @click="clearFilters" class="clear-button">
              <img src="@/assets/charm_cross.svg" alt="img" width="22" height="22" />
              <span class="filter-by">{{ $t("ClearFilters") }}</span>
            </button>
          </v-col>
        </v-row>
      </v-card>
    </v-card>

    <v-card class="data-table-card mt-6">
      <v-card-text style="padding: 0">
        <v-card-text>
          <h2 style="font-weight: 600; color: #171717;">{{ $t('logResults') }}</h2>
        </v-card-text>

          <v-data-table-server
            :headers="headers"
            :items="listLog.logDetail"
            :loading="loading"
            :items-length="listLog.allRow"
            :items-per-page="itemsPerPage"
            @update:options="options = $event"
            class="pa-4"
          >
          <template #no-data>
            <div class="d-flex justify-center align-center fixed" style="width: 100%">
              <span style="color: #646464; font-weight: 400;">{{ $t('noDataAvailable') }}</span>
            </div>
          </template>

            <template v-slot:item.logType="{ item }">
              <div
                class="log-type-badge"
                :class="getLogTypeClass(item.columns.logType)"
              >
                <v-icon size="16" class="mr-1">{{
                  getLogTypeIcon(item.columns.logType)
                }}</v-icon>
                {{ item.columns.logType }}
              </div>
            </template>

            <template v-slot:item.timestamp="{ item }">
              <div class="timestamp-cell">
                <div class="date">{{ formatDate(item.columns.timestamp) }}</div>
                <div class="time">{{ formatTime(item.columns.timestamp) }}</div>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-center">
                <v-btn
                  icon
                  variant="text"
                  size="small"
                  color="primary"
                  @click="viewDetails(item)"
                  class="action-button mr-2"
                >
                  <v-icon>mdi-eye</v-icon>
                  <v-tooltip activator="parent" location="top"
                    >{{ $t('viewDetails') }}</v-tooltip
                  >
                </v-btn>
              </div>
            </template>

            <template v-slot:bottom>
              <div class="table-bottom-group">
                <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                  <div>{{ $t('totalResults') }} {{ listLog.allRow }}</div>
    
                  <v-data-table-footer
                    :items="[
                      { text: '10', value: 10 },
                      { text: '25', value: 25 },
                      { text: '50', value: 50 },
                      { text: '100', value: 100 },
                      { text: 'All', value: -1 },
                    ]"
                    :page="options.page"
                    :length="Math.ceil(listLog.allRow / itemsPerPage)"
                  />
                </div>
              </div>
            </template>
          </v-data-table-server>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "LogEvent",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    detailsExpanded: false,
    isInitialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    type: "All",
    userChannel: "",
    sessionID: "",
    totalRow: 0,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dateFiltersApplied: {
      startDate: null,
      endDate: null,
    },
    appliedFilters: {
      apiNameQuery: null,
      actionQuery: null,
      statusCodeQuery: null,
      statusApiQuery: null,
      createByQuery: null,
    },
    apiNameQuery: null,
    actionQuery: null,
    statusCodeQuery: null,
    statusApiQuery: null,
    createByQuery: null,
    listLog: {
      allRow: 0,
      logDetail: [
        {
          id: 0,
          apiName: "",
          action: "",
          statusCode: 0,
          statusApi: 0,
          exception: "",
          createBy: "",
          createDate: "",
        },
      ],
    },
    expandDateFilter: false, // ปิดโดย default
    expandFilters: false, // ปิดโดย default
    loading: false,
    sortBy: [],
    sortDesc: [],
    isSearch: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    actionList: [
      { name: "Create", value: "Create" },
      { name: "Delete", value: "Delete" },
      { name: "Update", value: "Update" },
    ],
    statusCode: [
      { name: "OK", value: 200 },
      { name: "Bad request", value: 400 },
      { name: "Internal server error", value: 500 },
    ],
    statusApi: [
      { name: "Succesful", value: 0 },
      { name: "Error", value: 1 },
      { name: "System error", value: 2 },
      { name: "Duplicate", value: 3 },
      { name: "Less", value: 4 },
      { name: "Exception", value: 5 },
    ],
  }),
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.fetchLog();
      },
      deep: true,
    },
  },
  mounted() {
    this.GetDate();
    const date = new Date();
    this.startDate = this.convertDateToString2(date);
    this.endDate = this.convertDateToString2(date);
    this.appliedFilters = {
      apiNameQuery: null,
      actionQuery: null,
      statusCodeQuery: null,
      statusApiQuery: null,
      createByQuery: null,
    };
    this.Search();
    this.isInitialized = true;
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("noCol"),
          align: "left",
          value: "id",
          sortable: false,
          width: "4%",
        },
        {
          title: this.$t("apiNameCol"),
          align: "left",
          value: "apiName",
          sortable: true,
          width: "15%",
        },
        {
          title: this.$t("action"),
          align: "left",
          value: "action",
          sortable: true,
          width: "8%",
        },
        {
          title: this.$t("statusCodeCol"),
          align: "left",
          value: "statusCode",
          sortable: true,
          width: "16%",
        },
        {
          title: this.$t("statusApiCol"),
          align: "left",
          value: "statusApi",
          sortable: true,
          width: "14%",
        },
        {
          title: this.$t("messageCol"),
          align: "left",
          value: "exception",
          sortable: false,
          width: "15%",
        },
        {
          title: this.$t("createByCol"),
          align: "left",
          value: "createBy",
          sortable: true,
          width: "18%",
        },
        {
          title: this.$t("createDateCol"),
          align: "left",
          value: "createDate",
          sortable: true,
          width: "20%",
        },
      ];
    },
    // เพิ่ม computed properties
    hasActiveFilters() {
      return (
        this.apiNameQuery ||
        this.createByQuery ||
        this.actionQuery ||
        this.statusCodeQuery ||
        this.statusApiQuery
      );
    },

    activeFilterCount() {
      let count = 0;
      if (this.apiNameQuery) count++;
      if (this.createByQuery) count++;
      if (this.actionQuery) count++;
      if (this.statusCodeQuery) count++;
      if (this.statusApiQuery) count++;
      return count;
    },
  },
  methods: {
    clearFilters() {
      this.apiNameQuery = null;
      this.createByQuery = null;
      this.actionQuery = null;
      this.statusCodeQuery = null;
      this.statusApiQuery = null;

      this.appliedFilters.apiNameQuery = null;
      this.appliedFilters.actionQuery = null;
      this.appliedFilters.statusCodeQuery = null;
      this.appliedFilters.statusApiQuery = null;
      this.appliedFilters.createByQuery = null;
      
      this.options.page = 1;
      this.fetchLog();
    },
    formatNumber(value) {
      return value.toLocaleString();
    },
    Search() {
      this.isSearch = true;
      this.dateFiltersApplied.startDate = this.startDate;
      this.dateFiltersApplied.endDate = this.endDate;
      this.options.page = 1;
      this.fetchLog();
    },
    fetchLog() {
      const { page, itemsPerPage } = this.options;
      this.loading = true;
      this.sortBy =
        this.options.sortBy == undefined || this.options.sortBy.length == 0
          ? null
          : this.options.sortBy[0];
      this.sortDesc =
        this.options.sortDesc == undefined || this.options.sortDesc.length == 0
          ? null
          : this.options.sortDesc[0];
      const tempData = {
        startDate: this.startDate,
        stopDate: this.endDate,
        page: page,
        pageResult: itemsPerPage,
        apiNameQuery: this.appliedFilters.apiNameQuery,
        actionQuery: this.appliedFilters.actionQuery,
        statusCodeQuery: this.appliedFilters.statusCodeQuery,
        statusApiQuery: this.appliedFilters.statusApiQuery,
        createByQuery: this.appliedFilters.createByQuery,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      this.$call.GetEventLog(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listLog.logDetail = dataResponse.data.listData;
            if (this.listLog.logDetail.length != 0) {
              this.listLog.allRow = dataResponse.data.allRow;
              this.listLog.logDetail.forEach((log) => {
                log.createDate = this.Utc2Thai(log.createDate);
                log.statusCode =
                  this.statusCode.find((item) => item.value == log.statusCode)?.name ?? "-";
                log.statusApi =
                  this.statusApi.find((item) => item.value == log.statusApi)?.name ?? "-";
                log.apiName = log.apiName || "-";
                log.action = log.action || "-";
                log.exception = log.exception || "-";
                log.createBy = log.createBy || "-";
              });
            }
            this.loading = false;
            this.isSearch = false;
          }
        },
        (errorResource) => {
          this.loading = false;
          console.error(errorResource);
        }
      );
    },
    Utc2Thai(Input) {
      if (!Input) {
        return "-";
      }

      const utc = new Date(Input);
      if (Number.isNaN(utc.getTime())) {
        return "-";
      }

      const local = new Date(utc.getTime() + 7 * 60 * 60 * 1000);
      const day = String(local.getDate()).padStart(2, "0");
      const month = String(local.getMonth() + 1).padStart(2, "0");
      const year = String(local.getFullYear()).slice();
      const hours = String(local.getHours()).padStart(2, "0");
      const minutes = String(local.getMinutes()).padStart(2, "0");
      // Format the date as dd/mm/yy hh:mm
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    getExceptionStyle(exception) {
      return exception == "-" ? { textAlign: "center" } : { textAlign: "left" }; //make exception placeholder center when it's was used
    },
    refreshData() {
      this.appliedFilters.apiNameQuery = this.apiNameQuery;
      this.appliedFilters.actionQuery = this.actionQuery;
      this.appliedFilters.statusCodeQuery = this.statusCodeQuery;
      this.appliedFilters.statusApiQuery = this.statusApiQuery;
      this.appliedFilters.createByQuery = this.createByQuery;
      this.options.page = 1;
      this.fetchLog();
    },
    viewDetails(item) {
      this.selectedLog = item.columns;
      this.dialogDetail = true;
    },
  },
};
</script>
<style scoped>
.log-event-container {
  min-height: 100vh;
  padding: 16px;
}

.heading-text {
  color: #171717;
  font-weight: 600;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.card2 {
  border: 1px solid rgba(201, 201, 201, 1) !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}
.card-title {
  color: #171717;
  font-weight: 600;
  font-size: 14px;
}
.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}
.search-divider {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.date-divider {
  color: #c9c9c9;
  font-weight: 700;
  margin-top: 50px;
}
.search-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  height: 34px;
  width: 34px;
  border-radius: 18px;
  margin-left: -8px;
}
.action-divider {
  width: 2px;
  height: 60px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  transition: background-color 0.2s ease;
  margin-top: 6px;
}
.advance-filters {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
}
/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) { display: none !important; }
.v-input--density-default {
    --v-input-control-height: none;
}
.advanced-filter-card {
  background: rgba(239, 244, 255, 0.5) !important;
  border-radius: 16px;
  box-shadow: none;
}
.modern-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  margin-top: -5px;
}
.modern-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.modern-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.download-btn {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 120px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 6px;
  margin-top: 28px;
}
.download-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.clear-button {
  display: flex;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 140px;
  margin-top: 28px;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
}
.clear-button:hover {
  background: rgba(56, 89, 208, 0.1);
  border-radius: 10px;
}
.clear-button-style {
  margin-left: 52px;
}
.filter-by {
  color: #3859D0;
  font-size: 13px;
}
.data-table-card {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
}
/* table style */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.table-bottom-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.main-card {
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
  overflow: hidden;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
  display: flex;
  align-items: center;
}

.filter-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  height: 100%;
}

.modern-input :deep(.v-field) {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
}

.modern-input :deep(.v-field:hover) {
  background-color: #f1f5f9 !important;
}
.modern-input :deep(.v-field__input) {
  padding: 8px 12px !important;
}

.search-button {
  background: linear-gradient(135deg, #4ade80 0%, #16a34a 100%) !important;
  box-shadow: 0 4px 14px rgba(22, 163, 74, 0.25) !important;
  transition: all 0.3s ease !important;
  min-width: 120px;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(22, 163, 74, 0.35) !important;
}

.button-text {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.results-section {
  padding: 0 16px 16px 16px;
}

.log-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 40px;
  font-size: 0.8125rem;
  font-weight: 500;
}

.log-type-badge.type-info {
  background-color: #e0f2fe;
  color: #0369a1;
}

.log-type-badge.type-warning {
  background-color: #fef3c7;
  color: #b45309;
}

.log-type-badge.type-error {
  background-color: #fee2e2;
  color: #b91c1c;
}

.timestamp-cell {
  display: flex;
  flex-direction: column;
}

.timestamp-cell .date {
  font-weight: 500;
}

.timestamp-cell .time {
  font-size: 0.8125rem;
  color: #64748b;
}

.action-button {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.modern-dialog :deep(.v-card) {
  border-radius: 16px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(to right, #f8fafc, #f1f5f9);
}

.dialog-title {
  color: #1e293b;
  font-weight: 700;
  margin: 0;
}

.dialog-content {
  padding: 24px !important;
}

.log-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.detail-group {
  margin-bottom: 16px;
}

.detail-label {
  font-weight: 600;
  font-size: 0.8125rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.detail-value {
  color: #111827;
  font-size: 0.9375rem;
}

.message-container {
  margin-bottom: 16px;
}

.message-content {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  color: #1f2937;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.session-id {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid #f1f5f9;
}

@media (max-width: 960px) {
  .search-button {
    width: 100%;
    margin-top: 16px;
  }
}

@media (max-width: 600px) {
  .log-event-container {
    padding: 8px;
  }

  .filter-section {
    padding: 12px;
  }

  .section-title {
    font-size: 1rem;
  }
}
</style>
